import "./dispute.css";
import { useEffect, useRef, useState } from "react";
import { CUSTOM_VALIDATION } from "../../../shared/validation/validation";
import { FormDropdown } from "../../../shared/components/form-component/form-dropdown";
import { FormInput } from "../../../shared/components/form-component/form-input";
import moment from "moment";
import { SERVICES } from "../../../core/services/services";
import { HELPER } from "../../../shared/helper/helper";
import { Toast } from "primereact/toast";
import { FormMultiselect } from "../../../shared/components/form-component/form-multiselect";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { DisputeTypes } from "../../../shared/constants";

export function DisputesFilter(props) {
  const toast = useRef(null);
  const [loading] = useState(false);
  const [dispute, setDispute] = useState({
    paymentFacilitatorId: null,
    resolutionStatus: null,
    disputeStatus: null,
    logCode: null,
    customerAccountNumber: null,
    mandateReference: null,
    transactionStatus: null,
    transactionEndDate: null,
    transactionStartDate: null,
    loggedOnEndDate: moment().format("YYYY-MM-DD"),
    loggedOnStartDate: moment().format("YYYY-MM-DD"),
  });
  const [formErrors, setFormErrors] = useState({
    paymentFacilitatorId: null,
    resolutionStatus: null,
    disputeStatus: null,
    logCode: null,
    customerAccountNumber: null,
    mandateReference: null,
    transactionStatus: null,
    transactionEndDate: null,
    transactionStartDate: null,
    loggedOnEndDate: null,
    loggedOnStartDate: null,
  });
  const resolutionStatuses = ["PENDING", "ACCEPTED", "DECLINED"];
  const [disputeStatuses] = useState(["PENDING", "RESOLVED", "TAT_EXPIRED"]);
  const [merchants, setMerchants] = useState([]);
  const [disputeDateFilterType, setDisputeDateFilterType] =
    useState("disputeLogDate");
  // const [errorResponseCodes, setErrorResponseCodes] = useState("");
  const [gettingMerchants, setGettingMerchants] = useState(false);

  useEffect(() => {
    function getMerchants() {
      setGettingMerchants(true);
      SERVICES.GET_ALL_MERCHANTS()
        .then((data) => {
          const result = data?.result;
          setMerchants(result);
          setGettingMerchants(false);
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Error getting merchants!",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 10000,
          });
          setGettingMerchants(false);
        });
    }
    if (
      props.disputeType ===
        DisputeTypes.Frontoffice.PaymentFacilitatorDisputes ||
      props.disputeType === DisputeTypes.Frontoffice.BankDisputes
    ) {
      // getMerchantsTiedToUser();
      return;
    } else {
      getMerchants();
    }
  }, [props.disputeType]);

  function validateForm(e, name, type, refineName, required) {
    let value = e?.target?.value;
    const isEmpty = CUSTOM_VALIDATION.IS_EMPTY(value);
    const isValidInput = !isEmpty
      ? CUSTOM_VALIDATION.BASIC_VALIDATION(value, type)
      : false;
    if (isValidInput) {
      setDispute({ ...dispute, [name]: value });
      setFormErrors({ ...formErrors, [name]: null });
    } else {
      setDispute({ ...dispute, [name]: null });

      let errorMessage =
        required && isEmpty ? `${refineName} is required` : null;
      if (!isValidInput) {
        errorMessage = `${refineName} is invalid`;
      }
      if (isEmpty) {
        setFormErrors({ ...formErrors, [name]: null });
      } else {
        setFormErrors({ ...formErrors, [name]: errorMessage });
      }
    }
  }

  function getFilters() {
    let payload = {};
    for (const property in dispute) {
      let value = dispute[property];
      if (dispute[property]) {
        if (property === "paymentFacilitatorId") {
          payload[property] = value.paymentFacilitatorId;
        } else if (
          property === "disputeStatus" &&
          (props.disputeType === DisputeTypes.Backoffice.BankDisputes ||
            props.disputeType ===
              DisputeTypes.Backoffice.PaymentFacilitatorDisputes)
        ) {
          payload[property] = dispute[property].length
            ? dispute[property].join(",")
            : "";
        } else {
          payload[property] = dispute[property];
        }
      }
    }

    return payload;
  }

  function cancelModal() {
    props.closeModal();
  }

  const cancelButton = () => {
    if (!loading) {
      return (
        <button onClick={cancelModal} className="secondary-button">
          Cancel
        </button>
      );
    } else {
      return <div />;
    }
  };

  function validateDropdown(e, name) {
    const value = e.target.value;
    if (value) {
      setFormErrors({ ...formErrors, [name]: "" });
      setDispute({ ...dispute, [name]: value });
    }
  }

  function validateMultipleSelect(e, name) {
    let value = e.target.value;
    if (value.length) {
      setDispute({ ...dispute, [name]: value });
    }
  }

  function handleDisputeDateFilterTypeChange(e) {
    const type = e?.target?.value;
    setDisputeDateFilterType(e?.target?.value);
    if (type === "transactionDate") {
      setDispute({
        ...dispute,
        loggedOnStartDate: null,
        loggedOnEndDate: null,
        transactionEndDate: moment().format("YYYY-MM-DD"),
        transactionStartDate: moment().format("YYYY-MM-DD"),
      });
    } else {
      setDispute({
        ...dispute,
        transactionEndDate: null,
        transactionStartDate: null,
        loggedOnStartDate: moment().format("YYYY-MM-DD"),
        loggedOnEndDate: moment().format("YYYY-MM-DD"),
      });
    }
  }

  const submitButton = () => {
    if (!loading) {
      return (
        <button
          onClick={() => props?.searchFunction(getFilters())}
          className="primary-button"
        >
          Filter
        </button>
      );
    } else {
      return (
        <div className="pull-up-element-2">
          {/* <DownloadProgress /> */}
          <CustomLoader loadingText="Loading..." />
        </div>
      );
    }
  };

  const filterDateTypeForm = () => {
    switch (disputeDateFilterType) {
      case "disputeLogDate":
        return (
          <>
            {/* <div className="p-col-12 p-pb-0">
              <p
                style={{ textAlign: "left", fontSize: "0.8rem" }}
                className="p-my-0"
              >
                Dispute Log Date
              </p>
            </div> */}
            <div className="p-col-6">
              <FormInput
                inputType="date"
                value={dispute["loggedOnStartDate"]}
                required={false}
                field="loggedOnStartDate"
                type="INPUT"
                error={formErrors["loggedOnStartDate"]}
                fn={validateForm}
                loading={loading}
                placeholder="Start date"
              />
            </div>
            <div className="p-col-6">
              <FormInput
                inputType="date"
                value={dispute["loggedOnEndDate"]}
                required={false}
                field="loggedOnEndDate"
                type="INPUT"
                error={formErrors["loggedOnEndDate"]}
                fn={validateForm}
                loading={loading}
                placeholder="End date"
              />
            </div>
          </>
        );
      case "transactionDate":
        return (
          <>
            {/* <div className="p-col-12 p-pb-0">
              <p
                style={{ textAlign: "left", fontSize: "0.8rem" }}
                className="p-my-0"
              >
                Transaction Date
              </p>
            </div> */}
            <div className="p-col-6">
              <FormInput
                inputType="date"
                value={dispute["transactionStartDate"]}
                required={false}
                field="transactionStartDate"
                type="INPUT"
                error={formErrors["transactionStartDate"]}
                fn={validateForm}
                loading={loading}
                placeholder="Start date"
              />
            </div>
            <div className="p-col-6">
              <FormInput
                inputType="date"
                value={dispute["transactionEndDate"]}
                required={false}
                field="transactionEndDate"
                type="INPUT"
                error={formErrors["transactionEndDate"]}
                fn={validateForm}
                loading={loading}
                placeholder="End date"
              />
            </div>
          </>
        );
      default:
        return;
    }
  };

  function shouldShowMerchantDropdown() {
    let showMerchantDropdown = false;
    if (
      props.disputeType === DisputeTypes.Backoffice.BankDisputes &&
      props.disputeType === DisputeTypes.Backoffice.PaymentFacilitatorDisputes
    ) {
      showMerchantDropdown = true;
    }

    return showMerchantDropdown;
  }

  const renderForm = () => {
    return (
      <div>
        <div className="custom-modal-title p-text-left">Filter</div>
        <div className="custom-dialog-subtitle-container p-mb-5"></div>
        <div className="p-grid">
          {shouldShowMerchantDropdown() && (
            <div className="p-col-12">
              <FormDropdown
                required={true}
                label="paymentFacilitatorName"
                field="paymentFacilitatorId"
                error={formErrors["paymentFacilitatorId"]}
                disabled={loading}
                value={dispute["paymentFacilitatorId"]}
                fn={validateDropdown}
                options={merchants}
                placeholder="Select Payment Facilitator"
                filter
                filterBy="paymentFacilitatorName"
                isLoading={gettingMerchants}
              />
            </div>
          )}
          <div className="p-col-12">
            <FormMultiselect
              required={false}
              error={formErrors["disputeStatus"]}
              field="disputeStatus"
              value={dispute["disputeStatus"]}
              options={disputeStatuses}
              fn={validateMultipleSelect}
              placeholder="Select dispute status"
            />
          </div>

          <div className="p-col-12">
            <FormDropdown
              required={false}
              // label="code"
              field="resolutionStatus"
              error={formErrors["resolutionStatus"]}
              disabled={loading}
              value={dispute["resolutionStatus"]}
              fn={validateDropdown}
              options={resolutionStatuses}
              placeholder="Select resolution status"
            />
          </div>
          {/* <div className="p-col-12"> */}
          {/* <FormDropdown
              required={false}
              // label="code"
              field="transactionStatus"
              error={formErrors["transactionStatus"]}
              disabled={loading}
              value={dispute["transactionStatus"]}
              fn={validateDropdown}
              options={transactionStatuses}
              placeholder="Select transaction status"
            /> */}
          {/* </div> */}
          <div className="p-col-12">
            <FormInput
              value={dispute["logCode"]}
              required={false}
              field="logCode"
              type="INPUT"
              error={formErrors["logCode"]}
              fn={validateForm}
              loading={loading}
              placeholder="Logcode"
            />
          </div>
          <div className="p-col-12">
            <FormInput
              value={dispute["customerAccountNumber"]}
              required={false}
              field="customerAccountNumber"
              type="INPUT"
              error={formErrors["customerAccountNumber"]}
              fn={validateForm}
              loading={loading}
              placeholder="Account number"
            />
          </div>
          <div className="p-col-12">
            <FormInput
              value={dispute["mandateReference"]}
              required={false}
              field="mandateReference"
              type="INPUT"
              error={formErrors["mandateReference"]}
              fn={validateForm}
              loading={loading}
              placeholder="Mandate reference"
            />
          </div>

          <div className="p-col-6">
            <label className="label">
              <input
                id="dispute-log-date"
                value="disputeLogDate"
                name="dateFilterType"
                type="radio"
                checked={disputeDateFilterType === "disputeLogDate"}
                onChange={handleDisputeDateFilterTypeChange}
              />
              <span>Dispute Log Date</span>
            </label>
          </div>
          <div className="p-col-6">
            <label className="label">
              <input
                id="transaction-date"
                value="transactionDate"
                name="dateFilterType"
                type="radio"
                checked={disputeDateFilterType === "transactionDate"}
                onChange={handleDisputeDateFilterTypeChange}
              />
              <span>Transaction Date</span>
            </label>
          </div>
          {filterDateTypeForm()}
          <div className="p-col-12">
            <div className="p-mt-2">
              <div className="p-grid">
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {cancelButton()}
                </div>
                {/* <div className={loading ? "p-col-12" : "p-col-4"}>
                  {downloadButton()}
                </div> */}
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {submitButton()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <Toast ref={toast} />
      </div>
      <div className="p-pb-2">{renderForm()}</div>
    </div>
  );
}
